import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountPagesComponent } from './account-pages.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { HelpModalModule } from 'src/app/components/help-modal/help-modal.module';



@NgModule({
  declarations: [AccountPagesComponent],
  imports: [SharedModule,
    CommonModule, HelpModalModule
  ],
  exports: [AccountPagesComponent]
})
export class AccountPagesModule { }
